<template>
  <validation-observer v-slot="{ invalid }">
    <proa-modal
      :modal="modal"
      :title="$t('common.addList')"
      @close="$emit('close')"
    >
      <validation-provider
        :name="$t('models.taskList.attributes.title')"
        rules="required|max:10"
        v-slot="{ errors }"
      >
        <proa-input-group :invalidFeedback="errors[0]">
          <template slot="input">
            <proa-input
              v-model="newTaskList.title"
              :invalid="errors.length != 0"
              :disabled="requesting"
              type="text"
              dark
            />
          </template>
        </proa-input-group>
      </validation-provider>
      <template slot="footer">
        <proa-button
          @click.native="$emit('close')"
          :disabled="requesting"
          class="default-button-width mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="$emit('onClickCreateTaskList', newTaskList)"
          :disabled="invalid"
          :loading="requesting"
          variant="primary"
          class="default-button-width"
        >
          {{ $t('common.ok') }}
        </proa-button>
      </template>
    </proa-modal>
  </validation-observer>
</template>

<script>
export default {
  name: 'AddTaskListModal',
  props: {
    modal: Boolean,
    requesting: Boolean
  },
  data() {
    return {
      newTaskList: null
    }
  },
  methods: {
    initNewTaskList: function() {
      this.newTaskList = {
        title: ''
      }
    }
  },
  watch: {
    modal: function() {
      this.initNewTaskList()
    }
  }
}
</script>
